import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Cell } from '@nousmedis/cc-types';
import { CellService } from 'app/modules/catalog-cloud/services/cell.service';
import { PageService } from 'app/modules/catalog-cloud/services/page.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-cc-cell-add-note-form',
  templateUrl: './cc-cell-add-note-form.component.html',
  styleUrl: './cc-cell-add-note-form.component.scss'
})
export class CcCellAddNoteFormComponent implements OnInit {

  //idCatalog: string, idFascicle: string, idPage: string, idCell: string, cell: Cell)
  idCatalog: string;
  idFascicle: string;
  idPage: string;
  idCell: string;
  cell: Cell;
  constructor (
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private translate: TranslateService

  ) {

  }
  ngOnInit(): void {
    this.cell = this.dialogConfig.data.cell;

  }

  saveNote() {
    this.dialogRef.close(this.cell);
  }

  cancelNote() {
    this.cell.notes = "";
    this.dialogRef.close(this.cell);
  }

}
